import axios from "@/plugins/axios";
import unauthoriseAxios from "@/plugins/unauthoriseAxios";
import handlerAxios from "@/plugins/handlerAxios";
import handlerService from "@/services/handlerService";

//UnAuthorise
import unauthoriseHsm from "@/services/unauthoriseHsm";

//Authorise
import company from "@/services/company";
import companyRequestDoc from "@/services/companyRequestDoc";
import authentication from "@/services/authentication";
import country from "@/services/country";
import unauthorisedApi from "@/services/unauthorisedApi";
import currency from "@/services/currency";
import role from "@/services/role";
import user from "@/services/user";
import vehicle from "@/services/vehicle";
import vehicleCost from "@/services/vehicleCost";
import branch from "@/services/branch";
import gpt from "@/services/gpt";
import depot from "@/services/depot";
import incidentLogs from "@/services/incidentLogs";
import trailer from "@/services/trailer";
import driver from "@/services/driver";
import driverApp from "@/services/driverApp";
import controlTower from "@/services/controlTower";
import vehicleType from "@/services/vehicleType";
import trailerType from "@/services/trailerType";
import reportcenter from "@/services/reportcenter";
import containerType from "@/services/containerType";
import containerCategory from "@/services/containerCategory";
import lane from "@/services/lane";
import location from "@/services/location";
import bmr from "@/services/bmr";
import enquiry from "@/services/enquiry";
import customerContract from "@/services/customerContract";
import transporterContract from "@/services/transporterContract";
import bidding from "@/services/bidding";
import lrfq from "@/services/lrfq";
import city from "@/services/city";
import companyFuelSurcharge from "@/services/companyFuelSurcharge";
import customerAddress from "@/services/customerAddress";
import emailSubscriber from "@/services/emailSubscriber";
import customerOrder from "@/services/customerOrder";
import deliveryAdvice from "@/services/deliveryAdvice";
import deliveryAdviceCharge from "@/services/deliveryAdviceCharge";
import daHazardousCargo from "@/services/daHazardousCargo";
import legCharges from "@/services/legCharges";
import tripMilestone from "@/services/tripMilestone";
import charge from "@/services/charge";
import checkList from "@/services/checkList";
import termsCondition from "@/services/termsCondition";
import driverLeave from "@/services/driverLeave";
import maintenance from "@/services/maintenance";
import trip from "@/services/trip";
import department from "@/services/department";
import quotation from "@/services/quotation";
import dashboard from "@/services/dashboard";
import integration from "@/services/integration";
import milestone from "@/services/milestone";
import nationality from "@/services/nationality";
import general from "@/services/general";
import customerInvoice from "@/services/customerInvoice";
import transporterInvoice from "@/services/transporterInvoice";
import activityLogs from "@/services/activityLogs";
import reports from "@/services/reports";
import unClass from "@/services/unClass";
import imoClass from "@/services/imoClass";
import adrClass from "@/services/adrClass";
import bankDetails from "@/services/bankDetails";
import assetsAvailabilityDashboard from "@/services/assetsAvailabilityDashboard";
import report from "@/services/report";
import paymentReceipt from "@/services/paymentReceipt";
import bulkUpload from "@/services/bulkUpload";
import subHire from "@/services/subHire";
import milestoneTemplate from "@/services/milestoneTemplate";
import tripCustomMilestone from "@/services/tripCustomMilestone";
import gpsIntegration from "@/services/gpsIntegration";

import leaseDriverBonus from "@/services/leaseDriverBonus";
import subHireCommitment from "@/services/subHireCommitment";
import draftTrip from "@/services/draftTrip";
import sapBonusPayout from "@/services/sapBonusPayout";
import advancedReport from "@/services/advancedReport";
import emergencyOrder from "@/services/emergencyOrder";
import emergencyOrderContainer from "@/services/emergencyOrderContainer";
import vendorSubHireUpload from "@/services/vendorSubHireUpload";
import workload from "@/services/workload";

const api = {
  dashboard: dashboard(axios),
  company: company(axios),
  authentication: authentication(axios),
  companyRequestDoc: companyRequestDoc(axios),
  country: country(axios),
  unauthorisedApi: unauthorisedApi(unauthoriseAxios),
  currency: currency(axios),
  city: city(axios),
  role: role(axios),
  user: user(axios),
  gpsIntegration:gpsIntegration(axios),
  sapBonusPayout: sapBonusPayout(axios),
  vehicle: vehicle(axios),
  vehicleCost: vehicleCost(axios),
  reportcenter: reportcenter(axios),
  tripCustomMilestone:tripCustomMilestone(axios),
  milestoneTemplate:milestoneTemplate(axios),
  trailer: trailer(axios),
  driver: driver(axios),
  incidentLogs: incidentLogs(axios),
  driverApp: driverApp(axios),
  controlTower:controlTower(axios),
  vehicleType: vehicleType(axios),
  depot: depot(axios),
  trailerType: trailerType(axios),
  containerType: containerType(axios),
  containerCategory: containerCategory(axios),
  lane: lane(axios),
  location: location(axios),
  assetsAvailabilityDashboard:assetsAvailabilityDashboard(axios),
  bmr: bmr(axios),
  enquiry: enquiry(axios),
  customerContract: customerContract(axios),
  transporterContract: transporterContract(axios),
  bidding: bidding(axios),
  lrfq: lrfq(axios),
  companyFuelSurcharge: companyFuelSurcharge(axios),
  customerAddress: customerAddress(axios),
  legCharges: legCharges(axios),
  customerOrder: customerOrder(axios),
  deliveryAdvice: deliveryAdvice(axios),
  deliveryAdviceCharge: deliveryAdviceCharge(axios),
  daHazardousCargo: daHazardousCargo(axios),
  tripMilestone: tripMilestone(axios),
  charge: charge(axios),
  checkList: checkList(axios),
  termsCondition: termsCondition(axios),
  driverLeave: driverLeave(axios),
  maintenance: maintenance(axios),
  trip: trip(axios),
  department: department(axios),
  quotation: quotation(axios),
  integration: integration(axios),
  milestone: milestone(axios),
  nationality: nationality(axios),
  general: general(axios),
  customerInvoice: customerInvoice(axios),
  transporterInvoice: transporterInvoice(axios),
  activityLogs: activityLogs(axios),
  reports: reports(axios),
  branch: branch(axios),
  gpt: gpt(axios),
  emailSubscriber: emailSubscriber(axios),
  unClass: unClass(axios),
  imoClass: imoClass(axios),
  adrClass: adrClass(axios),
  bankDetails: bankDetails(axios),
  report: report(axios),
   advancedReport: advancedReport(axios),
  paymentReceipt: paymentReceipt(axios),
  bulkUpload: bulkUpload(axios),
  subHire: subHire(axios),
  leaseDriverBonus: leaseDriverBonus(axios),
  subHireCommitment: subHireCommitment(axios),
  draftTrip: draftTrip(axios),
  emergencyOrder: emergencyOrder(axios),
  emergencyOrderContainer: emergencyOrderContainer(axios),
  vendorSubHireUpload: vendorSubHireUpload(axios),
  workload: workload(axios),

  unauthoriseHsm: unauthoriseHsm(unauthoriseAxios),
};

export const handler = handlerService(handlerAxios);

export default api;
